import BaseModel from "../base_model.js";
import IdentificationStatusFilterModeEnum from "../../enums/identification_status_filter_mode.js";
import DeletionStatusFilterModeEnum from "../../enums/deletion_status_filter_mode.js";
import { UserPersonalInfoModel } from "./user_personal_info_model.js"
import I18n from "../../base/i18n.js";

class RawUserModel extends BaseModel {

  rawListFilters() {
    return [
      {
        name: "isIdentified",
        displayName: this.fieldDisplayName("isIdentified"),
        type: "enum",
        enum: IdentificationStatusFilterModeEnum,
        allowClear: true,
        clearItem: I18n.t("enum.identification_status_filter_mode.all"),
        multiple: false
      },
      {
        name: "deleteScope",
        displayName: this.fieldDisplayName("deleteScope"),
        type: "enum",
        enum: DeletionStatusFilterModeEnum,
        allowClear: true,
        clearItem: I18n.t("enum.deletion_status_filter_mode.all"),
        multiple: false
      }
    ]
  }

  rawListFields() {
    return [
      {
        name: "code",
        displayName: this.fieldDisplayName("code"),
        type: "text"
      },
      {
        name: "email",
        displayName: this.fieldDisplayName("email"),
        type: "text"
      },
      {
        name: "newsletter",
        displayName: this.fieldDisplayName("newsletter"),
        type: "boolean"
      },
      {
        name: "personalInfo",
        displayName: this.fieldDisplayName("personalInfo"),
        type: "model",
        model: UserPersonalInfoModel
      },
      {
        name: "isRegistrationCompleted",
        displayName: this.fieldDisplayName("isRegistrationCompleted"),
        type: "boolean",
      },
      {
        name: "registeredAt",
        displayName: this.fieldDisplayName("registeredAt"),
        type: "dateTime",
        dateFormat: "DD.MM.YYYY",
        timeFormat: "HH:mm",
        sortKey: "registered_at"
      },
      {
        name: "isIdentified",
        displayName: this.fieldDisplayName("isIdentified"),
        type: "boolean",
      },
      // {
      //   name: "identificationStatus",
      //   displayName: this.fieldDisplayName("identificationStatus"),
      //   enum: IdentificationStatusEnum,
      //   renderFunction: (user, column) => {
      //     const value  = this.identificationStatus(user);
      //     return <EnumCell column = { column }
      //                      value = { value } />
      //   }
      // },
    ]
  }

  i18nScope() {
    return "model.users.user";
  }

  displayValue(item) {
    if(!item) {
      return "";
    }
    const { personalInfo } = item;
    let names = []
    if(personalInfo) {
      if(personalInfo.firstName) {
        names.push(personalInfo.firstName);
      }
      if(personalInfo.lastName) {
        names.push(personalInfo.lastName);
      }
    }
    if(names.length === 0)
      return item.email;
    return names.join(" ");
  }

  identificationStatus(user) {
    const { identificationStatus, isIdentificationRequired } = user;
    if(identificationStatus === "unidentified" && isIdentificationRequired) {
      return "identification_required";
    }
    return identificationStatus;
  }

}
const UserModel = new RawUserModel();

export { RawUserModel, UserModel }
